import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'

export interface PaymentOrderState {
  paymentOrderList?: any
  paymentOrderDetail?: any
}

const initialState: PaymentOrderState = {
  paymentOrderList: {},
  paymentOrderDetail: {},
}

export const paymentOrderDucks = createSlice({
  name: 'paymentOrder',
  initialState,
  reducers: {

    getListPaymentOrder: (state: RootState, action: PayloadAction<any>) => {
      state.paymentOrderList = { loading: true, queryStr: action.payload }
    },
    getListPaymentOrderSuccess: (state, action: PayloadAction<any>) => {
      state.paymentOrderList = { loading: false, ...action.payload }
    },
    getListPaymentOrderFail: (state, action: PayloadAction<any>) => {
      state.paymentOrderList = { loading: false, ...action.payload }
    },

    getDetailPaymentOrder: (state: RootState, action: PayloadAction<any>) => {
      state.paymentOrderDetail = { loading: true, id: action.payload }
    },
    getDetailPaymentOrderSuccess: (state, action: PayloadAction<any>) => {
      state.paymentOrderDetail = { loading: false, ...action.payload }
    },
    getDetailPaymentOrderFail: (state, action: PayloadAction<any>) => {
      state.paymentOrderDetail = { loading: false, ...action.payload }
    },

  },
})

// Action creators are generated for each case reducer function
export const {
  getListPaymentOrder,
  getListPaymentOrderSuccess,
  getListPaymentOrderFail,
  getDetailPaymentOrder,
  getDetailPaymentOrderSuccess,
  getDetailPaymentOrderFail,
  
} = paymentOrderDucks.actions

export default paymentOrderDucks.reducer
